// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Badge } from '@mantine/core';
import type { Patient } from '@medplum/fhirtypes';
import { isSelfPayPatient } from '@polarissleep/shared';
import type { JSX } from 'react';

export function SelfPayBadge({ patient }: { patient: Patient | undefined }): JSX.Element | null {
  if (!isSelfPayPatient(patient)) {
    return null;
  }
  return (
    <Badge color="grape" variant="light">
      Self-Pay
    </Badge>
  );
}
